// extracted by mini-css-extract-plugin
export default {"wrapper":"status_wrapper__RpWLg","status":"status_status__-eGJf","optional":"status_optional__5eYp3","text":"status_text__2Eje6"};